// MUI widgets, global tags, slick, CircularProgressbar, list chrome, and dark
// Bamburgh selectors live in muiWidgetGlobals (folded leftover CssBaseline dumps).

const muiWidgetGlobals = {
  ".shadow-overflow": {
    position: "relative",
    "&::before, &::after": {
      width: "100%",
      left: 0,
      height: "1rem",
      position: "absolute",
      zIndex: 4,
      content: "\"\"",
    },
    "&::before": {
      top: 0,
      background: "linear-gradient(to bottom, rgba(255,255,255,1) 20%, rgba(255,255,255,0) 100%)",
    },
    "&::after": {
      bottom: 0,
      top: "auto",
      background: "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 80%)",
    },
  },
  ".MuiSlider-root .MuiSlider-rail": {
    height: 4,
    borderRadius: "0.65rem",
    background: "#dfe0ea",
    opacity: 1,
  },
  ".MuiSlider-root .MuiSlider-track": {
    height: 4,
    borderRadius: "0.65rem",
  },
  ".MuiSlider-root .MuiSlider-thumb": {
    width: 16,
    height: 16,
    marginLeft: -8,
    border: "2px solid transparent",
    background: "#fff",
  },
  ".MuiSwitch-root": {
    width: 58,
    height: 38,
    padding: 0,
    overflow: "visible",
    "& .MuiSwitch-switchBase": {
      padding: 9,
      color: "#fff",
      "&.Mui-checked": {
        transform: "translateX(20px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: "#368cff",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      width: 20,
      height: 20,
      boxShadow: "0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)",
    },
    "& .MuiSwitch-track": {
      borderRadius: 50,
      opacity: 1,
      backgroundColor: "#dfe0ea",
    },
  },
  ".MuiTabs-root": {
    minHeight: 42,
    overflow: "visible !important",
  },
  ".MuiTab-root": {
    minHeight: 42,
    height: "100%",
  },
  ".MuiPagination-root .MuiPaginationItem-root": {
    borderRadius: "0.25rem !important",
    width: 36,
    minWidth: 36,
    height: 36,
    fontWeight: "bold",
  },
  ".MuiDialog-paper .MuiDialogTitle-root": {
    borderBottom: "1px solid #e6e7f1",
  },
  ".MuiDialog-paper .MuiDialogActions-root": {
    borderTop: "1px solid #e6e7f1",
  },
  ".MuiLinearProgress-root": {
    height: "1rem",
  },
  "@keyframes progress-active": {
    "0%": {
      opacity: 0.4,
      width: 0,
    },
    "100%": {
      opacity: 0,
      width: "100%",
    },
  },
  ".MuiTooltip-tooltip": {
    boxShadow: "0 0.125rem 0.25rem rgba(7, 9, 25, 0.075)",
  },
  ".MuiSnackbar-root": {
    zIndex: 2500,
  },
  ".MuiInputBase-root:not(.MuiInput-underline).Mui-focused": {
    boxShadow: "0 0 0 0.2rem rgba(54, 140, 255, 0.25)",
  },
  ".hf-place-autocomplete-host, [data-hf-place-host]": {
    width: "100%",
  },
  ".hf-place-autocomplete-host gmp-place-autocomplete, [data-hf-place-host] gmp-place-autocomplete, gmp-place-autocomplete, gmp-basic-place-autocomplete": {
    width: "100%",
    minHeight: 40,
    colorScheme: "light",
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.87)",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    borderRadius: 4,
    fontSize: 14,
    boxSizing: "border-box",
  },
  ".hf-place-autocomplete-host gmp-place-autocomplete:focus-within, [data-hf-place-host] gmp-place-autocomplete:focus-within, gmp-place-autocomplete:focus-within, gmp-basic-place-autocomplete:focus-within": {
    borderColor: "var(--primary, #368cff)",
    borderWidth: 2,
  },
  "gmp-place-autocomplete::part(input), gmp-basic-place-autocomplete::part(input)": {
    color: "rgba(0, 0, 0, 0.87)",
    caretColor: "rgba(0, 0, 0, 0.87)",
  },
  "gmp-place-autocomplete::part(prediction-item-main-text), gmp-basic-place-autocomplete::part(prediction-item-main-text)": {
    color: "rgba(0, 0, 0, 0.87)",
  },
  "gmp-place-autocomplete::part(prediction-item), gmp-basic-place-autocomplete::part(prediction-item)": {
    color: "rgba(0, 0, 0, 0.6)",
  },
  ".hf-place-autocomplete-field, [data-hf-place-field]": {
    width: "100%",
    position: "relative",
    minHeight: 40,
    marginTop: 0,
  },
  ".hf-place-autocomplete-field > input, [data-hf-place-field] > input": {
    display: "none",
  },
  "body .MuiButtonBase-root": {
    minWidth: "0",
    outline: "none !important",
  },
  "body .MuiButton-root": {
    lineHeight: "initial",
  },
  "body .MuiButton-root:focus": {
    outline: "none",
  },
  "body .MuiPaper-root": {
    color: "#3b3e66",
  },
  ".MuiGrid-item,\n.MuiPaper-root:not(.MuiDrawer-paper) .MuiPaper-root:not(.MuiAppBar-root)": {
    position: "relative",
  },
  ".MuiCard-root": {
    transition: "all 0.2s ease-in-out",
  },
  "a.MuiButton-outlined:hover": {
    color: "initial",
  },
  ".MuiTablePagination-root .MuiTablePagination-toolbar": {
    alignItems: "center",
  },
  ".MuiTablePagination-root .MuiTablePagination-displayedRows,\n.MuiTablePagination-root .MuiTablePagination-selectLabel": {
    marginTop: "0",
    marginBottom: "0",
  },
  ".MuiTablePagination-root .MuiTablePagination-actions": {
    display: "flex",
    alignItems: "center",
  },
  "body .MuiOutlinedInput-notchedOutline": {
    transition: "all 0.2s ease-in-out",
  },
  "body .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#368cff",
  },
  "@keyframes float": {
    "0%": {
      transform: "rotateY(0deg) rotateZ(0deg) translateZ(0px) rotateX(0deg) translateY(0px)",
    },
    "50%": {
      transform: "rotateY(-2deg) rotateZ(-2deg) translateZ(-5px) rotateX(-4deg) translateY(-15px)",
    },
    "75%": {
      transform: "rotateY(4deg) rotateZ(4deg) translateZ(8px) rotateX(8deg) translateY(8px)",
    },
    "100%": {
      transform: "rotateY(0deg) rotateZ(0deg) translateZ(0px) rotateX(0deg) translateY(0px)",
    },
  },
  ".badge": {
    display: "inline-block",
    padding: "0 0.7em",
    fontSize: "0.75rem",
    fontWeight: 700,
    lineHeight: "21px",
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "baseline",
    borderRadius: "0.65rem",
    textTransform: "uppercase",
    height: 20,
    "&:empty": {
      display: "none",
    },
  },
  ".MuiChip-root:not(.MuiChip-outlined)": {
    backgroundColor: "#368cff",
    color: "#fff",
    "& .MuiChip-deleteIcon": {
      color: "#fff",
    },
    "&.Mui-disabled": {
      opacity: 0.65,
    },
  },
  ".arrow_box": {
    position: "relative",
    background: "#2a2a2a",
    border: "1px solid rgba(255, 255, 255, 0.16)",
    borderRadius: 4,
    color: "#fff !important",
    "& span": {
      color: "#fff !important",
      padding: "6px 10px",
      display: "inline-block",
    },
  },
  ".arrow_box.hf-chart-tooltip": {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 12px",
    "& span": {
      padding: 0,
    },
  },
  ".hf-chart-tooltip-dot": {
    width: 10,
    height: 10,
    borderRadius: "50%",
    flexShrink: 0,
    display: "inline-block !important",
    padding: "0 !important",
  },
  ".hf-chart-tooltip-label": {
    color: "#fff !important",
    fontWeight: 600,
    lineHeight: 1.3,
  },
  ".apexcharts-tooltip, .apexcharts-tooltip span, .apexcharts-tooltip-text, .apexcharts-theme-light .arrow_box, .apexcharts-theme-light .arrow_box span": {
    color: "#fff !important",
  },
  ".apexcharts-data-labels text, .apexcharts-datalabel": {
    fill: "#3b3e66 !important",
  },
  ".MuiListItem-root.MuiListItem-button .MuiTouchRipple-root, .MuiListItemButton-root .MuiTouchRipple-root": {
    opacity: 0.5,
  },
  ".MuiCard-root > .MuiList-root:last-child .MuiListItem-root:last-child": {
    borderBottomLeftRadius: "0.65rem",
    borderBottomRightRadius: "0.65rem",
  },
  "@media (max-width: 1439.98px)": {
    ".grid-menu .MuiGrid-item:nth-last-of-type(-n+2)": {
      borderBottomWidth: 1,
    },
    ".grid-menu .MuiGrid-item:nth-of-type(1n)": {
      borderRightWidth: 1,
    },
    ".grid-menu .MuiGrid-item:nth-of-type(2n)": {
      borderRightWidth: 0,
    },
    ".divider-v.divider-v-lg": {
      top: "auto",
      bottom: 0,
      right: "auto",
      left: 0,
      width: "100%",
      height: 1,
      minHeight: 1,
    },
  },
  "@media (max-width: 767.98px)": {
    ".divider-v.divider-v-md": {
      top: "auto",
      bottom: 0,
      width: "100%",
      height: 1,
      minHeight: 1,
    },
  },
  "@media (max-width: 575.98px)": {
    ".divider-v.divider-v-md": {
      display: "none",
    },
  },
  ".MuiList-root .MuiListItem-root": {
    margin: "2px 0",
  },
  ".MuiList-root .MuiListItem-root.MuiListItem-button, .MuiList-root .MuiListItemButton-root": {
    borderRadius: "0.29rem",
    transition: "all 0.2s ease-in-out",
    margin: "2px 0",
  },
  ".gm-ui-hover-effect": {
    display: "none !important",
  },
  ".gm-style .gm-style-iw-c": {
    padding: 0,
  },
  ".gm-style-iw-d": {
    padding: 0,
    overflow: "auto !important",
  },
  ".pac-container": {
    zIndex: 1301,
  },
  ".pac-item": {
    color: "rgba(0, 0, 0, 0.6)",
    cursor: "pointer",
  },
  ".pac-item-query": {
    color: "rgba(0, 0, 0, 0.87)",
  },
  ".arrow_box:after, .arrow_box:before": {
    right: "100%",
    top: "50%",
    border: "solid transparent",
    content: "\" \"",
    height: 0,
    width: 0,
    position: "absolute",
    pointerEvents: "none",
  },
  ".arrow_box:after": {
    borderColor: "rgba(55, 61, 63, 0)",
    borderRightColor: "#2a2a2a",
    borderWidth: 10,
    marginTop: -10,
  },
  ".arrow_box:before": {
    borderColor: "rgba(0, 0, 0, 0)",
    borderRightColor: "#1f1f1f",
    borderWidth: 13,
    marginTop: -13,
  },
  ".apexcharts-tooltip": {
    transform: "translateX(10px) translateY(10px)",
    overflow: "visible !important",
    whiteSpace: "normal !important",
    zIndex: "10000 !important",
    background: "#2a2a2a !important",
    color: "#fff !important",
    border: "1px solid rgba(255, 255, 255, 0.16) !important",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
  },
  ".apexcharts-tooltip:has(.arrow_box)": {
    background: "transparent !important",
    border: "none !important",
    boxShadow: "none !important",
    padding: "0 !important",
  },
  ".apexcharts-tooltip-title": {
    background: "#333 !important",
    color: "#fff !important",
    borderBottom: "1px solid rgba(255, 255, 255, 0.12) !important",
  },
  ".apexcharts-tooltip-series-group, .apexcharts-tooltip-series-group.apexcharts-active": {
    background: "transparent !important",
    color: "#fff !important",
    padding: "6px 10px !important",
  },
  ".apexcharts-tooltip-marker": {
    width: "10px !important",
    height: "10px !important",
    borderRadius: "50% !important",
    marginRight: "8px !important",
  },
  ".apexcharts-tooltip-text, .apexcharts-tooltip-text-label, .apexcharts-tooltip-text-value, .apexcharts-tooltip-y-group, .apexcharts-tooltip-text-y-label, .apexcharts-tooltip-text-y-value": {
    color: "#fff !important",
  },
  ".apexcharts-inner, .apexcharts-canvas, .apexcharts-svg": {
    overflow: "visible !important",
  },
  "#shadow-host-companion": {
    display: "none !important",
  },
  ".MuiStepper-root.MuiStepper-alternativeLabel.stepper-horizontal-1": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
    "& .MuiStepConnector-alternativeLabel": {
      top: "50%",
      marginTop: -18,
    },
    "& .MuiStepLabel-alternativeLabel": {
      fontSize: "1rem",
      color: "#4f5062",
    },
    "& .MuiStepLabel-label.Mui-active": {
      color: "#368cff",
      fontWeight: 700,
    },
    "& .MuiStepLabel-label.Mui-completed": {
      color: "#1bc943",
      fontWeight: 700,
    },
  },
  ".MuiSwitch-root.switch-medium": {
    height: 32,
    width: 52,
  },
  ".MuiSwitch-root.switch-medium .MuiSwitch-switchBase": {
    padding: 6,
    height: 32,
    width: 32,
  },
  ".MuiSwitch-root.switch-small": {
    height: 22,
    width: 44,
  },
  ".MuiLinearProgress-root.progress-xs": {
    height: "0.3rem",
  },
  ".MuiLinearProgress-root.progress-sm": {
    height: "0.52rem",
  },
  ".MuiLinearProgress-root.progress-animated-alt .MuiLinearProgress-bar::after": {
    content: "\"\"",
    opacity: 0,
    position: "absolute",
    inset: 0,
    background: "#fff",
    animation: "progress-active 2s ease infinite",
  },
  ".MuiLinearProgress-root.progress-bar-success": {
    background: "#f4f5fd",
    "& .MuiLinearProgress-bar": {
      background: "#1bc943",
    },
  },
  ".MuiLinearProgress-root.progress-bar-danger": {
    background: "#f4f5fd",
    "& .MuiLinearProgress-bar": {
      background: "#f83245",
    },
  },
  ".MuiLinearProgress-root.progress-bar-first": {
    background: "#f4f5fd",
    "& .MuiLinearProgress-bar": {
      background: "#4191ff",
    },
  },
  ".MuiLinearProgress-root.progress-bar-warning": {
    background: "#f4f5fd",
    "& .MuiLinearProgress-bar": {
      background: "#f4772e",
    },
  },
  ".MuiMenu-paper .scroll-area": {
    height: "10rem",
  },
  "*": {
    outline: "none",
  },
  a: {
    transition: "color 0.2s",
  },
  ".pulse-animation": {
    transition: "all 0.2s ease-in-out",
    transform: "scale(1.1)",
    animation: "pulse 1s infinite",
  },
  "@keyframes pulse": {
    "0%": {
      transform: "scale(0.75)",
    },
    "20%": {
      transform: "scale(1.1)",
    },
    "40%": {
      transform: "scale(0.75)",
    },
    "60%": {
      transform: "scale(1.05)",
    },
    "80%": {
      transform: "scale(0.75)",
    },
    "100%": {
      transform: "scale(0.75)",
    },
  },
  "h1, h2, h3, h4, h5, h6": {
    marginBottom: "0.5rem",
    fontWeight: "500",
    lineHeight: "1.2",
    fontFamily: "Heebo, sans-serif",
  },
  h1: {
    fontSize: "2.5rem",
  },
  h2: {
    fontSize: "2rem",
  },
  h3: {
    fontSize: "1.75rem",
  },
  h4: {
    fontSize: "1.5rem",
  },
  h5: {
    fontSize: "1.25rem",
  },
  h6: {
    fontSize: "1rem",
  },
  ".h1": {
    fontSize: "2.5rem",
    fontWeight: 500,
    lineHeight: 1.2,
  },
  ".h2": {
    fontSize: "2rem",
    fontWeight: 500,
    lineHeight: 1.2,
  },
  ".h3": {
    fontSize: "1.75rem",
    fontWeight: 500,
    lineHeight: 1.2,
  },
  ".h4": {
    fontSize: "1.5rem",
    fontWeight: 500,
    lineHeight: 1.2,
  },
  ".h5": {
    fontSize: "1.25rem",
    fontWeight: 500,
    lineHeight: 1.2,
  },
  ".h6": {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: 1.2,
  },
  ".block-ui": {
    position: "relative",
    minHeight: "3em",
  },
  ".block-ui-container": {
    position: "absolute",
    zIndex: "1010",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    height: "100%",
    minHeight: "2em",
    cursor: "wait",
    overflow: "hidden",
  },
  ".block-ui-container:focus": {
    outline: "none",
  },
  ".block-ui-overlay": {
    width: "100%",
    height: "100%",
    background: "rgba(255, 255, 255, 0.8)",
  },
  "html[data-color-mode=\"dark\"] .block-ui-overlay": {
    background: "rgba(18, 18, 18, 0.82) !important",
  },
  "html[data-color-mode=\"dark\"] .block-ui-message": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  ".block-ui-message-container": {
    position: "absolute",
    top: "50%",
    left: "0",
    right: "0",
    textAlign: "center",
    transform: "translateY(-50%)",
    zIndex: "10001",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  ".block-ui-message": {
    color: "#3b3e66",
    background: "none",
    zIndex: "1011",
  },
  ".scrollbar-container": {
    position: "relative",
    height: "100%",
    maxHeight: "100%",
    overflowX: "hidden",
    overflowY: "auto",
    WebkitOverflowScrolling: "touch",
  },
  ".slick-slider": {
    position: "relative",
    display: "block",
    userSelect: "none",
    touchAction: "pan-y",
    maxWidth: "1400px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  ".slick-list": {
    position: "relative",
    overflow: "hidden",
    display: "block",
    margin: "0",
    padding: "0",
  },
  ".slick-list:focus": {
    outline: "none",
  },
  ".slick-list.dragging": {
    cursor: "hand",
  },
  ".slick-slider .slick-track,\n.slick-slider .slick-list": {
    transform: "translate3d(0, 0, 0)",
  },
  ".slick-track": {
    position: "relative",
    left: "0",
    top: "0",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
  },
  ".slick-track::before, .slick-track::after": {
    content: "\"\"",
    display: "table",
  },
  ".slick-track::after": {
    clear: "both",
  },
  ".slick-loading .slick-track": {
    visibility: "hidden",
  },
  ".slick-slide": {
    float: "left",
    height: "100%",
    minHeight: "1px",
    outline: "none",
    display: "none",
    borderRadius: "0.75rem",
  },
  ".slick-slide > div": {
    outline: "none",
    paddingRight: "1px",
  },
  ".slick-slide > div > div": {
    outline: "none",
  },
  ".slick-slide.slick-loading img": {
    display: "none",
  },
  ".slick-slide.dragging > *": {
    pointerEvents: "none",
  },
  ".slick-initialized .slick-slide": {
    display: "block",
  },
  ".slick-loading .slick-slide": {
    visibility: "hidden",
  },
  ".slick-vertical .slick-slide": {
    display: "block",
    height: "auto",
    border: "1px solid transparent",
  },
  ".slick-arrow.slick-hidden": {
    display: "none",
  },
  ".slick-slider-right .slick-arrow,\n.slick-slider-left .slick-arrow": {
    display: "none !important",
  },
  ".slick-slider-right .slick-list.draggable,\n.slick-slider-left .slick-list.draggable": {
    cursor: "all-scroll",
  },
  ".slick-slider-left .slick-dots": {
    textAlign: "left",
  },
  ".slick-slider-left .slick-dots li": {
    margin: "0 0.6666666667rem 0 0",
  },
  ".slick-prev,\n.slick-next": {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "44px",
    width: "44px",
    cursor: "pointer",
    color: "#368cff",
    top: "50%",
    padding: "0",
    border: "none",
    outline: "none",
    boxShadow: "0 0.313rem 0.8rem rgba(79, 80, 98, 0.5), 0 0.126rem 0.225rem rgba(79, 80, 98, 0.3)",
    transition: "all 0.2s ease-in-out",
    transform: "scale(1)",
    borderRadius: "50px",
    background: "#fff",
    zIndex: "6",
    overflow: "hidden",
    opacity: "0",
    marginTop: "-22px",
    left: "15px",
  },
  ".slick-prev > *,\n.slick-next > *": {
    height: "34px",
    width: "34px",
  },
  ".slick-prev:hover, .slick-prev:focus,\n.slick-next:hover,\n.slick-next:focus": {
    outline: "none",
    transform: "scale(1.15)",
  },
  ".slick-prev:active,\n.slick-next:active": {
    outline: "none",
    transform: "scale(1.05)",
  },
  ".slick-prev.slick-disabled:before,\n.slick-next.slick-disabled:before": {
    opacity: "0.25",
  },
  ".slick-prev > *": {
    left: "-1px",
    position: "relative",
  },
  ".slick-next": {
    left: "auto",
    right: "15px",
  },
  ".slick-slider:hover .slick-next,\n.slick-slider:hover .slick-prev": {
    opacity: "1",
  },
  ".slick-dots": {
    listStyle: "none",
    display: "block",
    textAlign: "center",
    padding: "0",
    margin: "0",
    width: "100%",
    height: "8px",
    position: "absolute",
    bottom: "15px",
    left: "0",
    right: "0",
  },
  ".slick-dots li": {
    position: "relative",
    display: "inline-block",
    padding: "0",
    margin: "0 0.3333333333rem",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
  },
  ".slick-dots li button": {
    border: "0",
    background: "#d1d2db",
    display: "block",
    height: "8px",
    width: "8px",
    padding: "0",
    cursor: "pointer",
    position: "relative",
    borderRadius: "0.65rem",
    color: "transparent",
    transition: "all 0.2s ease-in-out",
    outline: "none !important",
  },
  ".slick-dots li.slick-active button": {
    width: "26px",
    background: "#368cff",
  },
  ".slick-center": {
    transform: "scale(1.5)",
  },
  ".CircularProgressbar": {
    verticalAlign: "middle",
  },
  ".CircularProgressbar .CircularProgressbar-path": {
    strokeLinecap: "round",
    transition: "stroke-dashoffset 0.5s ease 0s",
  },
  ".CircularProgressbar .CircularProgressbar-trail": {
    strokeLinecap: "round",
  },
  ".CircularProgressbar .CircularProgressbar-text": {
    fontSize: "1.1rem",
    dominantBaseline: "middle",
    textAnchor: "middle",
    fontWeight: "bold",
  },
  ".CircularProgressbar.circular-progress-xs": {
    width: "48px",
  },
  ".CircularProgressbar.circular-progress-xs .CircularProgressbar-text": {
    fontSize: "1.6rem",
  },
  ".CircularProgressbar.circular-progress-sm": {
    width: "62px",
  },
  ".CircularProgressbar.circular-progress-sm .CircularProgressbar-text": {
    fontSize: "1.3rem",
  },
  ".CircularProgressbar.circular-progress-lg": {
    width: "120px",
  },
  ".CircularProgressbar.circular-progress-xl": {
    width: "140px",
  },
  ".CircularProgressbar.circular-progress-xxl": {
    width: "180px",
  },
  ".circular-progress-primary .CircularProgressbar-path": {
    stroke: "#368cff",
  },
  ".circular-progress-primary .CircularProgressbar-trail": {
    stroke: "rgba(54, 140, 255, 0.1)",
  },
  ".circular-progress-primary .CircularProgressbar-text": {
    fill: "#368cff",
  },
  ".circular-progress-primary .CircularProgressbar-background": {
    fill: "rgba(54, 140, 255, 0.05)",
  },
  ".circular-progress-secondary .CircularProgressbar-path": {
    stroke: "#f8f9ff",
  },
  ".circular-progress-secondary .CircularProgressbar-trail": {
    stroke: "rgba(248, 249, 255, 0.1)",
  },
  ".circular-progress-secondary .CircularProgressbar-text": {
    fill: "#f8f9ff",
  },
  ".circular-progress-secondary .CircularProgressbar-background": {
    fill: "rgba(248, 249, 255, 0.05)",
  },
  ".circular-progress-success .CircularProgressbar-path": {
    stroke: "#1bc943",
  },
  ".circular-progress-success .CircularProgressbar-trail": {
    stroke: "rgba(27, 201, 67, 0.1)",
  },
  ".circular-progress-success .CircularProgressbar-text": {
    fill: "#1bc943",
  },
  ".circular-progress-success .CircularProgressbar-background": {
    fill: "rgba(27, 201, 67, 0.05)",
  },
  ".circular-progress-info .CircularProgressbar-path": {
    stroke: "#11c5db",
  },
  ".circular-progress-info .CircularProgressbar-trail": {
    stroke: "rgba(17, 197, 219, 0.1)",
  },
  ".circular-progress-info .CircularProgressbar-text": {
    fill: "#11c5db",
  },
  ".circular-progress-info .CircularProgressbar-background": {
    fill: "rgba(17, 197, 219, 0.05)",
  },
  ".circular-progress-warning .CircularProgressbar-path": {
    stroke: "#f4772e",
  },
  ".circular-progress-warning .CircularProgressbar-trail": {
    stroke: "rgba(244, 119, 46, 0.1)",
  },
  ".circular-progress-warning .CircularProgressbar-text": {
    fill: "#f4772e",
  },
  ".circular-progress-warning .CircularProgressbar-background": {
    fill: "rgba(244, 119, 46, 0.05)",
  },
  ".circular-progress-danger .CircularProgressbar-path": {
    stroke: "#f83245",
  },
  ".circular-progress-danger .CircularProgressbar-trail": {
    stroke: "rgba(248, 50, 69, 0.1)",
  },
  ".circular-progress-danger .CircularProgressbar-text": {
    fill: "#f83245",
  },
  ".circular-progress-danger .CircularProgressbar-background": {
    fill: "rgba(248, 50, 69, 0.05)",
  },
  ".circular-progress-light .CircularProgressbar-path": {
    stroke: "#f4f5fd",
  },
  ".circular-progress-light .CircularProgressbar-trail": {
    stroke: "rgba(244, 245, 253, 0.1)",
  },
  ".circular-progress-light .CircularProgressbar-text": {
    fill: "#f4f5fd",
  },
  ".circular-progress-light .CircularProgressbar-background": {
    fill: "rgba(244, 245, 253, 0.05)",
  },
  ".circular-progress-gray .CircularProgressbar-path": {
    stroke: "#f8f9ff",
  },
  ".circular-progress-gray .CircularProgressbar-trail": {
    stroke: "rgba(248, 249, 255, 0.1)",
  },
  ".circular-progress-gray .CircularProgressbar-text": {
    fill: "#f8f9ff",
  },
  ".circular-progress-gray .CircularProgressbar-background": {
    fill: "rgba(248, 249, 255, 0.05)",
  },
  ".circular-progress-dark .CircularProgressbar-path": {
    stroke: "#4f5062",
  },
  ".circular-progress-dark .CircularProgressbar-trail": {
    stroke: "rgba(79, 80, 98, 0.1)",
  },
  ".circular-progress-dark .CircularProgressbar-text": {
    fill: "#4f5062",
  },
  ".circular-progress-dark .CircularProgressbar-background": {
    fill: "rgba(79, 80, 98, 0.05)",
  },
  ".circular-progress-first .CircularProgressbar-path": {
    stroke: "#4191ff",
  },
  ".circular-progress-first .CircularProgressbar-trail": {
    stroke: "rgba(65, 145, 255, 0.1)",
  },
  ".circular-progress-first .CircularProgressbar-text": {
    fill: "#4191ff",
  },
  ".circular-progress-first .CircularProgressbar-background": {
    fill: "rgba(65, 145, 255, 0.05)",
  },
  ".circular-progress-second .CircularProgressbar-path": {
    stroke: "#070919",
  },
  ".circular-progress-second .CircularProgressbar-trail": {
    stroke: "rgba(7, 9, 25, 0.1)",
  },
  ".circular-progress-second .CircularProgressbar-text": {
    fill: "#070919",
  },
  ".circular-progress-second .CircularProgressbar-background": {
    fill: "rgba(7, 9, 25, 0.05)",
  },
  "html[data-color-mode=\"dark\"]": {
    "--hf-calc-hero-from": "#453c62",
    "--hf-calc-hero-to": "#2c2942",
  },
  "html[data-color-mode=\"dark\"] body": {
    backgroundColor: "#121212",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] #root": {
    backgroundColor: "#121212",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiPaper-root": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiAlert-root": {
    color: "rgba(255, 255, 255, 0.87) !important",
    overflow: "visible",
  },
  "html[data-color-mode=\"dark\"] .MuiAlert-standardSuccess .MuiAlert-icon, html[data-color-mode=\"dark\"] .MuiAlert-outlinedSuccess .MuiAlert-icon, html[data-color-mode=\"dark\"] .MuiAlert-filledSuccess .MuiAlert-icon": {
    color: "#1bc943 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiAlert-standardInfo .MuiAlert-icon, html[data-color-mode=\"dark\"] .MuiAlert-outlinedInfo .MuiAlert-icon": {
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiCardHeader-root": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiAccordion-root": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiAccordionSummary-root": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiAccordionDetails-root": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiStepper-root": {
    backgroundColor: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] .MuiStepLabel-label": {
    color: "rgba(255, 255, 255, 0.68) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiStepLabel-label.Mui-active": {
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiStepLabel-label.Mui-completed": {
    color: "#81c784 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .MuiList-root .MuiListItem-root": {
    backgroundColor: "#1e1e1e !important",
    borderColor: "rgba(255, 255, 255, 0.12) !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .MuiList-root .MuiListItemButton-root": {
    backgroundColor: "#1e1e1e !important",
    borderColor: "rgba(255, 255, 255, 0.12) !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .MuiList-root .MuiListItem-root:hover": {
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .MuiList-root .MuiListItemButton-root:hover": {
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .MuiList-root[data-hf=\"unit-tabs\"] .MuiListItem-root, html[data-color-mode=\"dark\"] .MuiCard-root .MuiList-root[data-hf=\"unit-tabs\"] .MuiListItemButton-root, html[data-color-mode=\"dark\"] [data-hf=\"unit-tabs\"] .MuiListItem-root, html[data-color-mode=\"dark\"] [data-hf=\"unit-tabs\"] .MuiListItemButton-root": {
    backgroundColor: "transparent !important",
    background: "transparent !important",
    color: "rgba(255, 255, 255, 0.55) !important",
    borderRadius: "0 !important",
    boxShadow: "none !important",
    borderColor: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .MuiList-root[data-hf=\"unit-tabs\"] .MuiListItem-root.Mui-selected, html[data-color-mode=\"dark\"] .MuiCard-root .MuiList-root[data-hf=\"unit-tabs\"] .MuiListItemButton-root.Mui-selected, html[data-color-mode=\"dark\"] [data-hf=\"unit-tabs\"] .MuiListItem-root.Mui-selected, html[data-color-mode=\"dark\"] [data-hf=\"unit-tabs\"] .MuiListItemButton-root.Mui-selected": {
    backgroundColor: "transparent !important",
    background: "transparent !important",
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .MuiList-root[data-hf=\"unit-tabs\"] .MuiListItem-root:hover, html[data-color-mode=\"dark\"] .MuiCard-root .MuiList-root[data-hf=\"unit-tabs\"] .MuiListItemButton-root:hover, html[data-color-mode=\"dark\"] .MuiCard-root .MuiList-root[data-hf=\"unit-tabs\"] .MuiListItemButton-root.Mui-selected:hover, html[data-color-mode=\"dark\"] [data-hf=\"unit-tabs\"] .MuiListItem-root:hover, html[data-color-mode=\"dark\"] [data-hf=\"unit-tabs\"] .MuiListItemButton-root:hover": {
    backgroundColor: "transparent !important",
    background: "transparent !important",
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .MuiList-root[data-hf=\"unit-tabs\"]::after, html[data-color-mode=\"dark\"] [data-hf=\"unit-tabs\"]::after": {
    background: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background-color: #fff\"]": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background-color:#fff\"]": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background-color: rgb(255, 255, 255)\"]": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background-color:rgb(255, 255, 255)\"]": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background: #eaf4ff\"]": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background:#eaf4ff\"]": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background-color: #f8f9fe\"]": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"wizard-stepper-track\"]": {
    backgroundColor: "#252525 !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background-color:#f8f9fe\"]": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background-color: #f8f9ff\"]": {
    backgroundColor: "#252525 !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background-color:#f8f9ff\"]": {
    backgroundColor: "#252525 !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"color: #070919\"]": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] [style*=\"color:#070919\"]": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background-color: #070919\"]": {
    backgroundColor: "#1e1e1e !important",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background-color:#070919\"]": {
    backgroundColor: "#1e1e1e !important",
  },
  "html[data-color-mode=\"dark\"] [style*=\"color: #183153\"]": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] [style*=\"color:#183153\"]": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] img[src*=\"/images/\"][src*=\"Cards/\"]": {
    filter: "invert(0.9) hue-rotate(180deg) brightness(0.95) contrast(1.05)",
  },
  "html[data-color-mode=\"dark\"] .reactour__popover": {
    backgroundColor: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .CircularProgressbar-text": {
    fill: "rgba(255, 255, 255, 0.9) !important",
  },
  "html[data-color-mode=\"dark\"] .CircularProgressbar-background": {
    fill: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .CircularProgressbar-trail": {
    stroke: "rgba(255, 255, 255, 0.22) !important",
  },
  "html[data-color-mode=\"dark\"] .apexcharts-text": {
    fill: "rgba(255, 255, 255, 0.68) !important",
  },
  "html[data-color-mode=\"dark\"] .apexcharts-data-labels text, html[data-color-mode=\"dark\"] .apexcharts-datalabel, html[data-color-mode=\"dark\"] .apexcharts-datalabels-group text, html[data-color-mode=\"dark\"] .apexcharts-datalabel-label, html[data-color-mode=\"dark\"] .apexcharts-datalabel-value": {
    fill: "rgba(255, 255, 255, 0.87) !important",
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .apexcharts-legend-text": {
    color: "rgba(255, 255, 255, 0.68) !important",
  },
  "html[data-color-mode=\"dark\"] .apexcharts-gridline": {
    stroke: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiLinearProgress-root": {
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .apexcharts-tooltip": {
    background: "#2a2a2a !important",
    color: "#fff !important",
    border: "1px solid rgba(255, 255, 255, 0.16) !important",
  },
  "html[data-color-mode=\"dark\"] .apexcharts-tooltip-title": {
    background: "#333 !important",
    color: "#fff !important",
    borderBottom: "1px solid rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .apexcharts-tooltip-series-group, html[data-color-mode=\"dark\"] .apexcharts-tooltip-series-group.apexcharts-active": {
    background: "transparent !important",
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] .apexcharts-tooltip-text, html[data-color-mode=\"dark\"] .apexcharts-tooltip-text-label, html[data-color-mode=\"dark\"] .apexcharts-tooltip-text-value, html[data-color-mode=\"dark\"] .apexcharts-tooltip-text-y-label, html[data-color-mode=\"dark\"] .apexcharts-tooltip-text-y-value": {
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] .hf-place-autocomplete-host gmp-place-autocomplete, html[data-color-mode=\"dark\"] [data-hf-place-host] gmp-place-autocomplete, html[data-color-mode=\"dark\"] gmp-place-autocomplete, html[data-color-mode=\"dark\"] gmp-basic-place-autocomplete": {
    colorScheme: "dark",
    backgroundColor: "#2a2a2a",
    color: "rgba(255, 255, 255, 0.87)",
    borderColor: "rgba(255, 255, 255, 0.28)",
  },
  "html[data-color-mode=\"dark\"] gmp-place-autocomplete::part(input), html[data-color-mode=\"dark\"] gmp-basic-place-autocomplete::part(input)": {
    color: "rgba(255, 255, 255, 0.87) !important",
    caretColor: "rgba(255, 255, 255, 0.87)",
    backgroundColor: "transparent",
  },
  "html[data-color-mode=\"dark\"] gmp-place-autocomplete::part(prediction-list), html[data-color-mode=\"dark\"] gmp-basic-place-autocomplete::part(prediction-list)": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] gmp-place-autocomplete::part(prediction-item), html[data-color-mode=\"dark\"] gmp-basic-place-autocomplete::part(prediction-item)": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.68) !important",
  },
  "html[data-color-mode=\"dark\"] gmp-place-autocomplete::part(prediction-item):hover, html[data-color-mode=\"dark\"] gmp-place-autocomplete::part(prediction-item-selected), html[data-color-mode=\"dark\"] gmp-basic-place-autocomplete::part(prediction-item):hover, html[data-color-mode=\"dark\"] gmp-basic-place-autocomplete::part(prediction-item-selected)": {
    backgroundColor: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] gmp-place-autocomplete::part(prediction-item-main-text), html[data-color-mode=\"dark\"] gmp-place-autocomplete::part(prediction-item-match), html[data-color-mode=\"dark\"] gmp-place-autocomplete::part(prediction-item-nonmatch), html[data-color-mode=\"dark\"] gmp-basic-place-autocomplete::part(prediction-item-main-text), html[data-color-mode=\"dark\"] gmp-basic-place-autocomplete::part(prediction-item-match), html[data-color-mode=\"dark\"] gmp-basic-place-autocomplete::part(prediction-item-nonmatch)": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] gmp-place-autocomplete::part(prediction-item-secondary-text), html[data-color-mode=\"dark\"] gmp-basic-place-autocomplete::part(prediction-item-secondary-text)": {
    color: "rgba(255, 255, 255, 0.68) !important",
  },
  "html[data-color-mode=\"dark\"] .pac-container": {
    backgroundColor: "#1e1e1e !important",
    borderColor: "rgba(255, 255, 255, 0.12) !important",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.5)",
  },
  "html[data-color-mode=\"dark\"] .pac-item": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.68) !important",
    borderTopColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .pac-item:hover, html[data-color-mode=\"dark\"] .pac-item-selected": {
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .pac-item-query, html[data-color-mode=\"dark\"] .pac-matched": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .pac-item span": {
    color: "rgba(255, 255, 255, 0.68) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.Mui-disabled": {
    opacity: "1",
    cursor: "not-allowed",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-contained.Mui-disabled": {
    color: "rgba(255, 255, 255, 0.72) !important",
    backgroundColor: "rgba(54, 140, 255, 0.28) !important",
    border: "1px solid rgba(54, 140, 255, 0.45)",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-contained.Mui-disabled .MuiTypography-root": {
    color: "rgba(255, 255, 255, 0.72) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"delete-icon-blob\"]": {
    backgroundColor: "rgba(248, 50, 69, 0.18) !important",
    color: "#ff6b7a !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"delete-icon-blob\"] .svg-inline--fa": {
    color: "#ff6b7a !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"delete-danger-btn\"].MuiButton-contained:not(.Mui-disabled)": {
    backgroundColor: "#f83245 !important",
    color: "#fff !important",
    border: "1px solid #f83245",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"delete-danger-btn\"].MuiButton-contained.Mui-disabled": {
    backgroundColor: "rgba(248, 50, 69, 0.32) !important",
    border: "1px solid rgba(248, 50, 69, 0.45) !important",
    color: "rgba(255, 255, 255, 0.62) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-text.Mui-disabled, html[data-color-mode=\"dark\"] .MuiButton-outlined.Mui-disabled": {
    color: "rgba(255, 255, 255, 0.45) !important",
    backgroundColor: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] .text-dark": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .text-second": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .text-body": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .text-black-50": {
    color: "rgba(255, 255, 255, 0.68) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"muted\"]": {
    color: "rgba(255, 255, 255, 0.68) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiMenu-paper .MuiButton-root:hover, html[data-color-mode=\"dark\"] .MuiPopover-paper .MuiButton-root:hover": {
    backgroundColor: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .text-muted": {
    color: "rgba(255, 255, 255, 0.68) !important",
  },
  "html[data-color-mode=\"dark\"] .text-first": {
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .text-primary": {
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] a.text-first": {
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] a.text-primary": {
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .bg-white": {
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .bg-secondary": {
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .bg-light": {
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .bg-gray": {
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .border": {
    borderColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .border-top": {
    borderColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .border-bottom": {
    borderColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .border-light": {
    borderColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .divider": {
    borderColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .card-box .card-header": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .card-box .card-header--title": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .card-box .card-header--title b": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .card-box .card-footer": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .card-header": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .card-header--title": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .card-header--title b": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .card-footer": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .card .card-header": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .card .card-header--title": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .card .card-header--title b": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .card .card-footer": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .card-box .card-header--title > small": {
    opacity: "0.65",
    color: "rgba(255, 255, 255, 0.7)",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .card-header--title > small": {
    opacity: "0.65",
    color: "rgba(255, 255, 255, 0.7)",
  },
  "html[data-color-mode=\"dark\"] .card .card-header--title > small": {
    opacity: "0.65",
    color: "rgba(255, 255, 255, 0.7)",
  },
  "html[data-color-mode=\"dark\"] .card-box a:not(.MuiButton-root):not([class*=btn-]):not(.MuiIconButton-root)": {
    color: "#90caf9",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root a:not(.MuiButton-root):not([class*=btn-]):not(.MuiIconButton-root)": {
    color: "#90caf9",
  },
  "html[data-color-mode=\"dark\"] .card a:not(.MuiButton-root):not([class*=btn-]):not(.MuiIconButton-root)": {
    color: "#90caf9",
  },
  "html[data-color-mode=\"dark\"] .table thead th": {
    color: "rgba(255, 255, 255, 0.87) !important",
    borderColor: "rgba(255, 255, 255, 0.12) !important",
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .MuiTable-root thead th, html[data-color-mode=\"dark\"] table thead th": {
    color: "rgba(255, 255, 255, 0.87) !important",
    borderColor: "rgba(255, 255, 255, 0.12) !important",
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .table .thead-light th": {
    color: "rgba(255, 255, 255, 0.87) !important",
    borderColor: "rgba(255, 255, 255, 0.12) !important",
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .table .thead-dark th": {
    color: "rgba(255, 255, 255, 0.87) !important",
    borderColor: "rgba(255, 255, 255, 0.12) !important",
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .table th.MuiTableCell-root": {
    color: "rgba(255, 255, 255, 0.87) !important",
    borderColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .table td.MuiTableCell-root": {
    color: "rgba(255, 255, 255, 0.87) !important",
    borderColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .table td": {
    color: "rgba(255, 255, 255, 0.87) !important",
    borderColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .table th": {
    color: "rgba(255, 255, 255, 0.87) !important",
    borderColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .table th.MuiTableCell-head": {
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .table.table-alternate thead th": {
    color: "rgba(255, 255, 255, 0.87) !important",
    background: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] .MuiTableSortLabel-root": {
    color: "rgba(255, 255, 255, 0.7) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiTableSortLabel-root:hover": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiTableSortLabel-root.Mui-active": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiTableSortLabel-root .MuiTableSortLabel-icon": {
    color: "inherit !important",
    opacity: "0.7",
  },
  "html[data-color-mode=\"dark\"] .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon": {
    opacity: "1",
  },
  "html[data-color-mode=\"dark\"] .MuiTableCell-root": {
    color: "rgba(255, 255, 255, 0.87)",
    borderBottomColor: "rgba(255, 255, 255, 0.12)",
  },
  "html[data-color-mode=\"dark\"] .MuiPaginationItem-root": {
    color: "rgba(255, 255, 255, 0.7)",
  },
  "html[data-color-mode=\"dark\"] .MuiPaginationItem-root.Mui-selected": {
    color: "#fff",
    backgroundColor: "rgba(144, 202, 249, 0.24)",
  },
  "html[data-color-mode=\"dark\"] .list-group-item": {
    backgroundColor: "transparent",
    color: "rgba(255, 255, 255, 0.87)",
    borderColor: "rgba(255, 255, 255, 0.12)",
  },
  "html[data-color-mode=\"dark\"] .MuiInputBase-input": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiInputBase-input::placeholder": {
    color: "rgba(255, 255, 255, 0.45) !important",
    opacity: 1,
  },
  "html[data-color-mode=\"dark\"] .MuiAutocomplete-option": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiAlert-icon": {
    overflow: "visible",
    alignItems: "center",
    paddingTop: "4px",
    paddingBottom: "4px",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"file-size\"]": {
    backgroundColor: "#3a3228 !important",
    color: "#ffb74d !important",
  },
  "html[data-color-mode=\"dark\"] .MuiSelect-select": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiMenu-paper a:not(.MuiButton-root):not([class*=btn-])": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiPopover-paper a:not(.MuiButton-root):not([class*=btn-])": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiMenu-paper a:not(.MuiButton-root):not([class*=btn-]) .MuiTypography-root": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] .MuiMenu-paper a:not(.MuiButton-root):not([class*=btn-]) span": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] .MuiMenu-paper a:not(.MuiButton-root):not([class*=btn-]) svg": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] .MuiMenu-paper a:not(.MuiButton-root):not([class*=btn-]) .nav-link-icon": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] .MuiMenu-paper a:not(.MuiButton-root):not([class*=btn-]) .MuiSvgIcon-root": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] .MuiPopover-paper a:not(.MuiButton-root):not([class*=btn-]) .MuiTypography-root": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] .MuiPopover-paper a:not(.MuiButton-root):not([class*=btn-]) span": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] .MuiPopover-paper a:not(.MuiButton-root):not([class*=btn-]) svg": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] .MuiPopover-paper a:not(.MuiButton-root):not([class*=btn-]) .nav-link-icon": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] .MuiPopover-paper a:not(.MuiButton-root):not([class*=btn-]) .MuiSvgIcon-root": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] .MuiListItem-root": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiListItemButton-root": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiTab-root": {
    color: "rgba(255, 255, 255, 0.6)",
  },
  "html[data-color-mode=\"dark\"] .MuiTab-root.Mui-selected": {
    color: "rgba(255, 255, 255, 0.95)",
  },
  "html[data-color-mode=\"dark\"] .MuiOutlinedInput-root": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiInputBase-root": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255, 255, 255, 0.28)",
  },
  "html[data-color-mode=\"dark\"] .MuiInputBase-root .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255, 255, 255, 0.28)",
  },
  "html[data-color-mode=\"dark\"] .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255, 255, 255, 0.5)",
  },
  "html[data-color-mode=\"dark\"] .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255, 255, 255, 0.5)",
  },
  "html[data-color-mode=\"dark\"] .MuiFormLabel-root": {
    color: "rgba(255, 255, 255, 0.7)",
  },
  "html[data-color-mode=\"dark\"] .MuiInputLabel-root": {
    color: "rgba(255, 255, 255, 0.7)",
  },
  "html[data-color-mode=\"dark\"] .MuiFormHelperText-root": {
    color: "rgba(255, 255, 255, 0.68)",
  },
  "html[data-color-mode=\"dark\"] .MuiFormHelperText-root .MuiTypography-root": {
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiFormHelperText-root.Mui-error": {
    color: "#f48fb1",
  },
  "html[data-color-mode=\"dark\"] .MuiTypography-root.MuiTypography-colorTextPrimary": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiTypography-root.MuiTypography-colorTextSecondary": {
    color: "rgba(255, 255, 255, 0.72) !important",
  },
  "html[data-color-mode=\"dark\"] input:-webkit-autofill": {
    WebkitTextFillColor: "rgba(255, 255, 255, 0.92) !important",
    caretColor: "rgba(255, 255, 255, 0.92)",
    boxShadow: "0 0 0 1000px #2a2a2a inset !important",
    transition: "background-color 99999s ease-in-out 0s",
  },
  "html[data-color-mode=\"dark\"] input:-webkit-autofill:hover": {
    WebkitTextFillColor: "rgba(255, 255, 255, 0.92) !important",
    caretColor: "rgba(255, 255, 255, 0.92)",
    boxShadow: "0 0 0 1000px #2a2a2a inset !important",
    transition: "background-color 99999s ease-in-out 0s",
  },
  "html[data-color-mode=\"dark\"] input:-webkit-autofill:focus": {
    WebkitTextFillColor: "rgba(255, 255, 255, 0.92) !important",
    caretColor: "rgba(255, 255, 255, 0.92)",
    boxShadow: "0 0 0 1000px #2a2a2a inset !important",
    transition: "background-color 99999s ease-in-out 0s",
  },
  "html[data-color-mode=\"dark\"] input:-webkit-autofill:active": {
    WebkitTextFillColor: "rgba(255, 255, 255, 0.92) !important",
    caretColor: "rgba(255, 255, 255, 0.92)",
    boxShadow: "0 0 0 1000px #2a2a2a inset !important",
    transition: "background-color 99999s ease-in-out 0s",
  },
  "html[data-color-mode=\"dark\"] textarea:-webkit-autofill": {
    WebkitTextFillColor: "rgba(255, 255, 255, 0.92) !important",
    caretColor: "rgba(255, 255, 255, 0.92)",
    boxShadow: "0 0 0 1000px #2a2a2a inset !important",
    transition: "background-color 99999s ease-in-out 0s",
  },
  "html[data-color-mode=\"dark\"] textarea:-webkit-autofill:hover": {
    WebkitTextFillColor: "rgba(255, 255, 255, 0.92) !important",
    caretColor: "rgba(255, 255, 255, 0.92)",
    boxShadow: "0 0 0 1000px #2a2a2a inset !important",
    transition: "background-color 99999s ease-in-out 0s",
  },
  "html[data-color-mode=\"dark\"] textarea:-webkit-autofill:focus": {
    WebkitTextFillColor: "rgba(255, 255, 255, 0.92) !important",
    caretColor: "rgba(255, 255, 255, 0.92)",
    boxShadow: "0 0 0 1000px #2a2a2a inset !important",
    transition: "background-color 99999s ease-in-out 0s",
  },
  "html[data-color-mode=\"dark\"] select:-webkit-autofill": {
    WebkitTextFillColor: "rgba(255, 255, 255, 0.92) !important",
    caretColor: "rgba(255, 255, 255, 0.92)",
    boxShadow: "0 0 0 1000px #2a2a2a inset !important",
    transition: "background-color 99999s ease-in-out 0s",
  },
  "html[data-color-mode=\"dark\"] select:-webkit-autofill:hover": {
    WebkitTextFillColor: "rgba(255, 255, 255, 0.92) !important",
    caretColor: "rgba(255, 255, 255, 0.92)",
    boxShadow: "0 0 0 1000px #2a2a2a inset !important",
    transition: "background-color 99999s ease-in-out 0s",
  },
  "html[data-color-mode=\"dark\"] select:-webkit-autofill:focus": {
    WebkitTextFillColor: "rgba(255, 255, 255, 0.92) !important",
    caretColor: "rgba(255, 255, 255, 0.92)",
    boxShadow: "0 0 0 1000px #2a2a2a inset !important",
    transition: "background-color 99999s ease-in-out 0s",
  },
  "html[data-color-mode=\"dark\"] .MuiInputBase-input:-webkit-autofill": {
    WebkitTextFillColor: "rgba(255, 255, 255, 0.92) !important",
    caretColor: "rgba(255, 255, 255, 0.92)",
    boxShadow: "0 0 0 1000px #2a2a2a inset !important",
    transition: "background-color 99999s ease-in-out 0s",
  },
  "html[data-color-mode=\"dark\"] .MuiOutlinedInput-input:-webkit-autofill": {
    WebkitTextFillColor: "rgba(255, 255, 255, 0.92) !important",
    caretColor: "rgba(255, 255, 255, 0.92)",
    boxShadow: "0 0 0 1000px #2a2a2a inset !important",
    transition: "background-color 99999s ease-in-out 0s",
  },
  "html[data-color-mode=\"dark\"] .btn-input-select:hover": {
    borderColor: "rgba(255, 255, 255, 0.5)",
    color: "rgba(255, 255, 255, 0.87) !important",
    background: "rgba(255, 255, 255, 0.08)",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"btn-input-select\"]:hover": {
    borderColor: "rgba(255, 255, 255, 0.5)",
    color: "rgba(255, 255, 255, 0.87) !important",
    background: "rgba(255, 255, 255, 0.08)",
  },
  "html[data-color-mode=\"dark\"] .btn-input-select.active": {
    borderColor: "#1bc943",
    background: "#2a2a2a",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"btn-input-select\"].active": {
    borderColor: "#1bc943",
    background: "#2a2a2a",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"btn-input-select\"][data-hf-selected]": {
    borderColor: "#1bc943",
    background: "#2a2a2a",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .btn-input-select.active:hover": {
    background: "#333",
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"btn-input-select\"].active:hover": {
    background: "#333",
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"btn-input-select\"][data-hf-selected]:hover": {
    background: "#333",
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .btn-input-select.active .text-black-50": {
    color: "rgba(255, 255, 255, 0.6) !important",
  },
  "html[data-color-mode=\"dark\"] .btn-input-select.active .font-size-lg": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .btn-input-select.active b": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .btn-input-select.active span": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"btn-input-select\"].active .text-black-50": {
    color: "rgba(255, 255, 255, 0.6) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"btn-input-select\"].active .font-size-lg": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"btn-input-select\"].active b": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"btn-input-select\"].active span": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"btn-input-select\"][data-hf-selected] .text-black-50": {
    color: "rgba(255, 255, 255, 0.6) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"btn-input-select\"][data-hf-selected] .font-size-lg": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"btn-input-select\"][data-hf-selected] b": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"btn-input-select\"][data-hf-selected] span": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .shadow-overflow::before": {
    background: "linear-gradient(to bottom, rgb(30, 30, 30) 20%, rgba(30, 30, 30, 0) 100%) !important",
  },
  "html[data-color-mode=\"dark\"] .shadow-overflow::after": {
    background: "linear-gradient(to bottom, rgba(30, 30, 30, 0) 0%, rgb(30, 30, 30) 80%) !important",
  },
  "html[data-color-mode=\"dark\"] .shadow-overflow-horizontal::before": {
    background: "linear-gradient(to right, rgb(30, 30, 30) 20%, rgba(30, 30, 30, 0) 100%) !important",
  },
  "html[data-color-mode=\"dark\"] .shadow-overflow-horizontal::after": {
    background: "linear-gradient(to left, rgb(30, 30, 30) 20%, rgba(30, 30, 30, 0) 100%) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDivider-root": {
    borderColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiSlider-root .MuiSlider-rail": {
    backgroundColor: "rgba(255, 255, 255, 0.24) !important",
    opacity: "1 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiSlider-root .MuiSlider-track": {
    backgroundColor: "#368cff !important",
    border: "none",
  },
  "html[data-color-mode=\"dark\"] .MuiSlider-root .MuiSlider-thumb": {
    backgroundColor: "#368cff !important",
    borderColor: "#90caf9 !important",
    boxShadow: "0 0 0 4px rgba(54, 140, 255, 0.2)",
  },
  "html[data-color-mode=\"dark\"] .MuiSlider-root .MuiSlider-mark": {
    backgroundColor: "#90caf9 !important",
    opacity: "0.9",
  },
  "html[data-color-mode=\"dark\"] .MuiSlider-root .MuiSlider-markLabel": {
    color: "rgba(255, 255, 255, 0.7) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiSlider-root .MuiSlider-markLabel.MuiSlider-markLabelActive": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiSlider-root.MuiSlider-trackInverted .MuiSlider-mark": {
    backgroundColor: "rgba(255, 255, 255, 0.5) !important",
  },
  "html[data-color-mode=\"dark\"] .circular-progress-dark .CircularProgressbar-path": {
    stroke: "#1bc943 !important",
  },
  "html[data-color-mode=\"dark\"] .circular-progress-dark .CircularProgressbar-trail": {
    stroke: "rgba(255, 255, 255, 0.22) !important",
  },
  "html[data-color-mode=\"dark\"] .circular-progress-dark .CircularProgressbar-text": {
    fill: "rgba(255, 255, 255, 0.9) !important",
  },
  "html[data-color-mode=\"dark\"] .slick-prev": {
    background: "#2a2a2a !important",
    color: "#90caf9 !important",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.45)",
  },
  "html[data-color-mode=\"dark\"] .slick-next": {
    background: "#2a2a2a !important",
    color: "#90caf9 !important",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.45)",
  },
  "html[data-color-mode=\"dark\"] .slick-prev svg, html[data-color-mode=\"dark\"] .slick-next svg": {
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .slick-prev:hover": {
    background: "#333 !important",
    color: "#bbdefb !important",
  },
  "html[data-color-mode=\"dark\"] .slick-prev:focus": {
    background: "#333 !important",
    color: "#bbdefb !important",
  },
  "html[data-color-mode=\"dark\"] .slick-next:hover": {
    background: "#333 !important",
    color: "#bbdefb !important",
  },
  "html[data-color-mode=\"dark\"] .slick-next:focus": {
    background: "#333 !important",
    color: "#bbdefb !important",
  },
  "html[data-color-mode=\"dark\"] .MuiCheckbox-root": {
    color: "rgba(255, 255, 255, 0.7)",
    backgroundColor: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] .MuiCheckbox-root:hover": {
    backgroundColor: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] .MuiCheckbox-root.Mui-checked": {
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .dropzone": {
    backgroundColor: "#2a2a2a !important",
    borderColor: "rgba(255, 255, 255, 0.28) !important",
    color: "rgba(255, 255, 255, 0.7) !important",
  },
  "html[data-color-mode=\"dark\"] .dropzone-inner-wrapper": {
    backgroundColor: "#2a2a2a !important",
    borderColor: "rgba(255, 255, 255, 0.28) !important",
    color: "rgba(255, 255, 255, 0.7) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"dropzone\"]": {
    backgroundColor: "#2a2a2a !important",
    borderColor: "rgba(255, 255, 255, 0.28) !important",
    color: "rgba(255, 255, 255, 0.7) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"dropzone-inner\"]": {
    backgroundColor: "#2a2a2a !important",
    borderColor: "rgba(255, 255, 255, 0.28) !important",
    color: "rgba(255, 255, 255, 0.7) !important",
  },
  "html[data-color-mode=\"dark\"] .dropzone:hover": {
    borderColor: "#368cff !important",
    color: "rgba(255, 255, 255, 0.87) !important",
    backgroundColor: "#333 !important",
  },
  "html[data-color-mode=\"dark\"] .dropzone-inner-wrapper:hover": {
    borderColor: "#368cff !important",
    color: "rgba(255, 255, 255, 0.87) !important",
    backgroundColor: "#333 !important",
  },
  "html[data-color-mode=\"dark\"] .dropzone-inner-wrapper-add-comp:hover": {
    borderColor: "#368cff !important",
    color: "rgba(255, 255, 255, 0.87) !important",
    backgroundColor: "#333 !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"dropzone\"]:hover": {
    borderColor: "#368cff !important",
    color: "rgba(255, 255, 255, 0.87) !important",
    backgroundColor: "#333 !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"dropzone-inner\"]:hover": {
    borderColor: "#368cff !important",
    color: "rgba(255, 255, 255, 0.87) !important",
    backgroundColor: "#333 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper": {
    overflow: "visible",
  },
  "html[data-color-mode=\"dark\"] .MuiDialogContent-root[data-hf=\"places-dialog-content\"]": {
    overflow: "visible !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-outline-secondary": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-outline-secondary": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-outline-secondary:not(:disabled):hover": {
    background: "rgba(255, 255, 255, 0.08) !important",
    color: "rgba(255, 255, 255, 0.95) !important",
    boxShadow: "none !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-outline-secondary:hover": {
    background: "rgba(255, 255, 255, 0.08) !important",
    color: "rgba(255, 255, 255, 0.95) !important",
    boxShadow: "none !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-outline-secondary.active": {
    background: "rgba(255, 255, 255, 0.08) !important",
    color: "rgba(255, 255, 255, 0.95) !important",
    boxShadow: "none !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-outline-secondary:not(:disabled):hover": {
    background: "rgba(255, 255, 255, 0.08) !important",
    color: "rgba(255, 255, 255, 0.95) !important",
    boxShadow: "none !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-outline-secondary:hover": {
    background: "rgba(255, 255, 255, 0.08) !important",
    color: "rgba(255, 255, 255, 0.95) !important",
    boxShadow: "none !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-outline-secondary.active": {
    background: "rgba(255, 255, 255, 0.08) !important",
    color: "rgba(255, 255, 255, 0.95) !important",
    boxShadow: "none !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-outline-secondary:not(:disabled):hover .text-black": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-outline-secondary:not(:disabled):hover .font-weight-bold": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-outline-secondary:hover .text-black": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-outline-secondary:hover .font-weight-bold": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-outline-secondary.active .text-black": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-outline-secondary.active .font-weight-bold": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-outline-secondary:not(:disabled):hover .text-black": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-outline-secondary:not(:disabled):hover .font-weight-bold": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-outline-secondary:hover .text-black": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-outline-secondary:hover .font-weight-bold": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-outline-secondary.active .text-black": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-outline-secondary.active .font-weight-bold": {
    color: "rgba(255, 255, 255, 0.95) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-outline-secondary:not(:disabled):hover .text-black-50": {
    color: "rgba(255, 255, 255, 0.65) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-outline-secondary:hover .text-black-50": {
    color: "rgba(255, 255, 255, 0.65) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-outline-secondary.active .text-black-50": {
    color: "rgba(255, 255, 255, 0.65) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-outline-secondary:not(:disabled):hover .text-black-50": {
    color: "rgba(255, 255, 255, 0.65) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-outline-secondary:hover .text-black-50": {
    color: "rgba(255, 255, 255, 0.65) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-outline-secondary.active .text-black-50": {
    color: "rgba(255, 255, 255, 0.65) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-neutral-dark": {
    background: "rgba(255, 255, 255, 0.08) !important",
    color: "rgba(255, 255, 255, 0.92) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-neutral-dark": {
    background: "rgba(255, 255, 255, 0.08) !important",
    color: "rgba(255, 255, 255, 0.92) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-neutral-dark:hover": {
    background: "rgba(255, 255, 255, 0.14) !important",
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonBase-root.btn-neutral-dark.active": {
    background: "rgba(255, 255, 255, 0.14) !important",
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-neutral-dark:hover": {
    background: "rgba(255, 255, 255, 0.14) !important",
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButton-root.btn-neutral-dark.active": {
    background: "rgba(255, 255, 255, 0.14) !important",
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDataGrid-root": {
    color: "rgba(255, 255, 255, 0.87)",
    borderColor: "rgba(255, 255, 255, 0.12)",
  },
  "html[data-color-mode=\"dark\"] .MuiDataGrid-root .MuiDataGrid-columnHeaders": {
    backgroundColor: "#2a2a2a",
  },
  "html[data-color-mode=\"dark\"] .MuiDataGrid-root .MuiDataGrid-columnHeaderTitle": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .MuiDataGrid-root .MuiDataGrid-cell": {
    borderBottomColor: "rgba(255, 255, 255, 0.08)",
  },
  "html[data-color-mode=\"dark\"] .MuiDataGrid-root .MuiDataGrid-footerContainer": {
    backgroundColor: "#1e1e1e",
    borderTopColor: "rgba(255, 255, 255, 0.12)",
  },
  "html[data-color-mode=\"dark\"] .MuiDataGrid-root .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
    background: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDataGrid-root .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
    backgroundColor: "#666 !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header": {
    backgroundColor: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header": {
    backgroundColor: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header .MuiButton-root": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.9) !important",
    borderBottomColor: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header .MuiButton-root.btn-link": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.9) !important",
    borderBottomColor: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header button.MuiButton-root": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.9) !important",
    borderBottomColor: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header .MuiButton-root": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.9) !important",
    borderBottomColor: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header .MuiButton-root.btn-link": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.9) !important",
    borderBottomColor: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header button.MuiButton-root": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.9) !important",
    borderBottomColor: "transparent !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header .MuiButton-root:hover": {
    background: "#333 !important",
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header .MuiButton-root.btn-link:hover": {
    background: "#333 !important",
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header button.MuiButton-root:hover": {
    background: "#333 !important",
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header .MuiButton-root:hover": {
    background: "#333 !important",
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header .MuiButton-root.btn-link:hover": {
    background: "#333 !important",
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header button.MuiButton-root:hover": {
    background: "#333 !important",
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header .MuiButton-root span": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header .MuiButton-root [data-hf=\"accordion-icon\"]": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header .MuiButton-root svg": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header .MuiButton-root .svg-inline--fa": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header .MuiButton-root.btn-link span": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header .MuiButton-root.btn-link [data-hf=\"accordion-icon\"]": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header .MuiButton-root.btn-link svg": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header .MuiButton-root.btn-link .svg-inline--fa": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header button.MuiButton-root span": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header button.MuiButton-root [data-hf=\"accordion-icon\"]": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header button.MuiButton-root svg": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box > .MuiCard-root > .card-header button.MuiButton-root .svg-inline--fa": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header .MuiButton-root span": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header .MuiButton-root [data-hf=\"accordion-icon\"]": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header .MuiButton-root svg": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header .MuiButton-root .svg-inline--fa": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header .MuiButton-root.btn-link span": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header .MuiButton-root.btn-link [data-hf=\"accordion-icon\"]": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header .MuiButton-root.btn-link svg": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header .MuiButton-root.btn-link .svg-inline--fa": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header button.MuiButton-root span": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header button.MuiButton-root [data-hf=\"accordion-icon\"]": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header button.MuiButton-root svg": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box .card-header button.MuiButton-root .svg-inline--fa": {
    color: "inherit !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box.panel-open > .MuiCard-root > .card-header .MuiButton-root": {
    background: "#252525 !important",
    color: "rgba(255, 255, 255, 0.95) !important",
    borderBottomColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box.panel-open > .MuiCard-root > .card-header .MuiButton-root.btn-link": {
    background: "#252525 !important",
    color: "rgba(255, 255, 255, 0.95) !important",
    borderBottomColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion > .card-box.panel-open > .MuiCard-root > .card-header button.MuiButton-root": {
    background: "#252525 !important",
    color: "rgba(255, 255, 255, 0.95) !important",
    borderBottomColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box.panel-open .card-header .MuiButton-root": {
    background: "#252525 !important",
    color: "rgba(255, 255, 255, 0.95) !important",
    borderBottomColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box.panel-open .card-header .MuiButton-root.btn-link": {
    background: "#252525 !important",
    color: "rgba(255, 255, 255, 0.95) !important",
    borderBottomColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] body .accordion .card-box.panel-open .card-header button.MuiButton-root": {
    background: "#252525 !important",
    color: "rgba(255, 255, 255, 0.95) !important",
    borderBottomColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[data-hf=\"table-actions-btn\"]": {
    backgroundColor: "rgba(54, 140, 255, 0.22) !important",
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=e4eeff]": {
    backgroundColor: "rgba(54, 140, 255, 0.22) !important",
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=\"228": {
    backgroundColor: "rgba(54, 140, 255, 0.22) !important",
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] 238": {
    backgroundColor: "rgba(54, 140, 255, 0.22) !important",
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] 255\"]": {
    backgroundColor: "rgba(54, 140, 255, 0.22) !important",
    color: "#1a1a1a !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=\"rgb(228": {
    backgroundColor: "rgba(54, 140, 255, 0.22) !important",
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] 255)\"]": {
    backgroundColor: "rgba(54, 140, 255, 0.22) !important",
    color: "#1a1a1a !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=\"54": {
    backgroundColor: "rgba(54, 140, 255, 0.22) !important",
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] 140": {
    backgroundColor: "rgba(54, 140, 255, 0.22) !important",
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[data-hf=\"table-actions-btn\"] svg": {
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[data-hf=\"table-actions-btn\"] .svg-inline--fa": {
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=e4eeff] svg": {
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=e4eeff] .svg-inline--fa": {
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] 255\"] svg": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] 255\"] .svg-inline--fa": {
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] 255)\"] svg": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] 255)\"] .svg-inline--fa": {
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiDialogTitle-root": {
    backgroundColor: "#1e1e1e !important",
    color: "rgba(255, 255, 255, 0.95) !important",
    borderBottom: "1px solid rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiDialogContent-root": {
    borderColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiDialogContent-dividers": {
    borderColor: "rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiDialogActions-root": {
    backgroundColor: "#1e1e1e !important",
    borderTop: "1px solid rgba(255, 255, 255, 0.12) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiFormControlLabel-label": {
    color: "rgba(255, 255, 255, 0.82) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiCheckbox-root": {
    color: "rgba(255, 255, 255, 0.78) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiCheckbox-root.Mui-checked": {
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiFormLabel-root": {
    color: "rgba(255, 255, 255, 0.7) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiInputLabel-root": {
    color: "rgba(255, 255, 255, 0.7) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiFormLabel-root.Mui-focused": {
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiInputLabel-root.Mui-focused": {
    color: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255, 255, 255, 0.28) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255, 255, 255, 0.5) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#368cff !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiInputBase-input": {
    color: "rgba(255, 255, 255, 0.87) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiSelect-icon": {
    color: "rgba(255, 255, 255, 0.7)",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"soft-panel\"]": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background: #f8f9fc\"]": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background:#f8f9fc\"]": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background: rgb(248": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] 249": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] 252)\"]": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background:rgb(248": {
    background: "#2a2a2a !important",
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] .hf-report-tile.hf-report-tile--active": {
    backgroundColor: "rgba(255, 255, 255, 0.1) !important",
  },
  "html[data-color-mode=\"dark\"] [style*=\"#EBEBF0\"]": {
    backgroundColor: "rgba(255, 255, 255, 0.1) !important",
  },
  "html[data-color-mode=\"dark\"] [style*=\"rgb(235": {
    backgroundColor: "rgba(255, 255, 255, 0.1) !important",
  },
  "html[data-color-mode=\"dark\"] 235": {
    backgroundColor: "rgba(255, 255, 255, 0.1) !important",
  },
  "html[data-color-mode=\"dark\"] 240)\"]": {
    backgroundColor: "rgba(255, 255, 255, 0.1) !important",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background: #f5f5f5\"]": {
    background: "#2a2a2a !important",
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background:#f5f5f5\"]": {
    background: "#2a2a2a !important",
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background-color: #f5f5f5\"]": {
    background: "#2a2a2a !important",
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] [style*=\"background-color:#f5f5f5\"]": {
    background: "#2a2a2a !important",
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] [style*=\"backgroundColor: #f5f5f5\"]": {
    background: "#2a2a2a !important",
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] thead[style*=\"#f5f5f5\"]": {
    background: "#2a2a2a !important",
    backgroundColor: "#2a2a2a !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[data-hf=\"sidebar-actions-btn\"]": {
    color: "#1a1a1a !important",
    backgroundColor: "rgba(255, 255, 255, 0.92) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[data-hf=\"sidebar-actions-btn\"]:hover": {
    color: "#1a1a1a !important",
    backgroundColor: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[data-hf=\"sidebar-actions-btn\"]:focus": {
    color: "#1a1a1a !important",
    backgroundColor: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[data-hf=\"sidebar-actions-btn\"]:active": {
    color: "#1a1a1a !important",
    backgroundColor: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[data-hf=\"sidebar-actions-btn\"]:hover .MuiSvgIcon-root": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[data-hf=\"sidebar-actions-btn\"]:hover svg": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=\"background-color: white\"]": {
    color: "#1a1a1a !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=\"backgroundColor: white\"]": {
    color: "#1a1a1a !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=\"background-color:white\"]": {
    color: "#1a1a1a !important",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=\"rgb(255": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] 255": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[data-hf=\"sidebar-actions-btn\"] .MuiSvgIcon-root": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[data-hf=\"sidebar-actions-btn\"] svg": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=\"background-color: white\"] .MuiSvgIcon-root": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=\"background-color: white\"] svg": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=\"backgroundColor: white\"] .MuiSvgIcon-root": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=\"backgroundColor: white\"] svg": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=\"background-color:white\"] .MuiSvgIcon-root": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] .MuiIconButton-root[style*=\"background-color:white\"] svg": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] 255)\"] .MuiSvgIcon-root": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] 255\"] .MuiSvgIcon-root": {
    color: "#1a1a1a !important",
    fill: "currentColor",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonGroup-root:not(.btn-primary):not([class*=btn-]) .MuiButton-root:not(.btn-primary):not(.MuiButton-contained):not(.active)": {
    color: "rgba(255, 255, 255, 0.85) !important",
    borderColor: "rgba(255, 255, 255, 0.28) !important",
    backgroundColor: "rgba(255, 255, 255, 0.06)",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonGroup-root:not(.btn-primary):not([class*=btn-]) .MuiButton-root:not(.btn-primary):not(.MuiButton-contained):not(.active):hover": {
    backgroundColor: "rgba(255, 255, 255, 0.12) !important",
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonGroup-root:not(.btn-primary):not([class*=btn-]) .MuiButton-root.btn-primary": {
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonGroup-root:not(.btn-primary):not([class*=btn-]) .MuiButton-root.active": {
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] .MuiButtonGroup-root:not(.btn-primary):not([class*=btn-]) .MuiButton-root.MuiButton-contained": {
    color: "#fff !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"filter-minmax\"] .MuiButton-root:not([data-hf-selected])": {
    color: "rgba(255, 255, 255, 0.85) !important",
    borderColor: "rgba(255, 255, 255, 0.28) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"])": {
    color: "rgba(255, 255, 255, 0.75)",
  },
  "html[data-color-mode=\"dark\"] .MuiDrawer-paper .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"])": {
    color: "rgba(255, 255, 255, 0.75)",
  },
  "html[data-color-mode=\"dark\"] .MuiPopover-paper .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"])": {
    color: "rgba(255, 255, 255, 0.75)",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"])": {
    color: "rgba(255, 255, 255, 0.75)",
  },
  "html[data-color-mode=\"dark\"] .card .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"])": {
    color: "rgba(255, 255, 255, 0.75)",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"]) .MuiSvgIcon-root": {
    color: "inherit",
  },
  "html[data-color-mode=\"dark\"] .MuiDrawer-paper .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"]) .MuiSvgIcon-root": {
    color: "inherit",
  },
  "html[data-color-mode=\"dark\"] .MuiPopover-paper .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"]) .MuiSvgIcon-root": {
    color: "inherit",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"]) .MuiSvgIcon-root": {
    color: "inherit",
  },
  "html[data-color-mode=\"dark\"] .card .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"]) .MuiSvgIcon-root": {
    color: "inherit",
  },
  "html[data-color-mode=\"dark\"] .MuiDialog-paper .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"]):hover": {
    color: "rgba(255, 255, 255, 0.95)",
  },
  "html[data-color-mode=\"dark\"] .MuiDrawer-paper .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"]):hover": {
    color: "rgba(255, 255, 255, 0.95)",
  },
  "html[data-color-mode=\"dark\"] .MuiPopover-paper .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"]):hover": {
    color: "rgba(255, 255, 255, 0.95)",
  },
  "html[data-color-mode=\"dark\"] .MuiCard-root .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"]):hover": {
    color: "rgba(255, 255, 255, 0.95)",
  },
  "html[data-color-mode=\"dark\"] .card .MuiIconButton-root:not([data-hf=\"sidebar-actions-btn\"]):not([data-hf=\"table-actions-btn\"]):hover": {
    color: "rgba(255, 255, 255, 0.95)",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"error-boundary\"]": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"error-boundary\"] .MuiTypography-root": {
    color: "rgba(255, 255, 255, 0.87)",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"error-boundary\"] .MuiTypography-colorTextSecondary": {
    color: "rgba(255, 255, 255, 0.75) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"error-boundary\"] .MuiTypography-h6": {
    color: "rgba(255, 255, 255, 0.75) !important",
  },
  "html[data-color-mode=\"dark\"] [data-hf=\"error-boundary\"] .MuiTypography-body2": {
    color: "rgba(255, 255, 255, 0.75) !important",
  },
  "html[data-color-mode=\"dark\"] .MuiAvatar-root[data-hf=\"action-avatar\"]": {
    backgroundColor: "rgba(30, 30, 30, 0.92) !important",
    border: "1px solid rgba(255, 255, 255, 0.22) !important",
    color: "#90caf9 !important",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.45)",
  },
  "html[data-color-mode=\"dark\"] .MuiAvatar-root[data-hf=\"action-avatar\"] .svg-inline--fa": {
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
  "html[data-color-mode=\"dark\"] .MuiAvatar-root[data-hf=\"action-avatar\"] svg": {
    color: "#90caf9 !important",
    fill: "#90caf9 !important",
  },
}

export const cssBaselineOverrides = {
  ':root': {
    '--blue': '#4191ff',
    '--indigo': '#7420ff',
    '--purple': '#793de6',
    '--pink': '#fc26a4',
    '--red': '#f83245',
    '--orange': '#f4772e',
    '--yellow': '#ffc926',
    '--green': '#1bc943',
    '--teal': '#18e1a5',
    '--cyan': '#11c5db',
    '--white': '#fff',
    '--gray': '#f8f9ff',
    '--gray-dark': '#4f5062',
    '--primary': '#368cff',
    '--secondary': '#f8f9ff',
    '--success': '#1bc943',
    '--info': '#11c5db',
    '--warning': '#f4772e',
    '--danger': '#f83245',
    '--light': '#f4f5fd',
    '--dark': '#4f5062',
    '--first': '#4191ff',
    '--second': '#070919',
  },
  html: {
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    minHeight: '100%',
    height: 'auto',
  },
  '*, *::before, *::after': {
    boxSizing: 'inherit',
  },
  body: {
    minHeight: '100%',
    height: 'auto',
    margin: 0,
    padding: '0 !important',
    fontFamily: 'Heebo, sans-serif',
    fontSize: '1rem',
  },
  '#root': {
    minHeight: '100%',
  },
  '[tabindex="-1"]:focus:not(:focus-visible)': {
    outline: '0 !important',
  },
  hr: {
    boxSizing: 'content-box',
    height: 0,
    overflow: 'visible',
  },
  'h1, h2, h3, h4, h5, h6': {
    marginTop: 0,
    marginBottom: '0.5rem',
    fontFamily: 'Heebo, sans-serif',
  },
  p: {
    marginTop: 0,
    marginBottom: '1rem',
  },
  'abbr[title], abbr[data-original-title]': {
    textDecoration: 'underline dotted',
    cursor: 'help',
    borderBottom: 0,
    textDecorationSkipInk: 'none',
  },
  address: {
    marginBottom: '1rem',
    fontStyle: 'normal',
    lineHeight: 'inherit',
  },
  'ol, ul, dl': {
    marginTop: 0,
    marginBottom: '1rem',
  },
  'ol ol, ul ul, ol ul, ul ol': {
    marginBottom: 0,
  },
  dt: {
    fontWeight: 700,
  },
  dd: {
    marginBottom: '0.5rem',
    marginLeft: 0,
  },
  blockquote: {
    margin: '0 0 1rem',
  },
  small: {
    fontSize: '80%',
  },
  'sub, sup': {
    position: 'relative',
    fontSize: '75%',
    lineHeight: 0,
    verticalAlign: 'baseline',
  },
  sub: {
    bottom: '-0.25em',
  },
  sup: {
    top: '-0.5em',
  },
  'a:not(.MuiButtonBase-root)': {
    color: '#3b3e66',
    textDecoration: 'none',
    backgroundColor: 'transparent',
    '&:hover': {
      color: '#4191ff',
      textDecoration: 'none',
    },
  },
  'a.card.card-box': {
    backgroundColor: '#fff',
  },
  'a:not([href])': {
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
      color: 'inherit',
      textDecoration: 'none',
    },
  },
  'pre, code, kbd, samp': {
    fontFamily: '"Times New Roman", Times, serif',
    fontSize: '1em',
  },
  pre: {
    marginTop: 0,
    marginBottom: '1rem',
    overflow: 'auto',
  },
  figure: {
    margin: '0 0 1rem',
  },
  img: {
    verticalAlign: 'middle',
    borderStyle: 'none',
  },
  svg: {
    overflow: 'hidden',
    verticalAlign: 'middle',
  },
  table: {
    borderCollapse: 'collapse',
  },
  caption: {
    paddingTop: '0.75rem',
    paddingBottom: '0.75rem',
    color: '#a6a6b9',
    textAlign: 'left',
    captionSide: 'bottom',
  },
  th: {
    textAlign: 'inherit',
  },
  label: {
    display: 'inline-block',
    marginBottom: 0,
  },
  button: {
    borderRadius: 0,
  },
  'button:focus': {
    outline: '5px auto -webkit-focus-ring-color',
  },
  'input, button, select, optgroup, textarea': {
    margin: 0,
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
  },
  'button, input': {
    overflow: 'visible',
  },
  'button, select': {
    textTransform: 'none',
  },
  select: {
    wordWrap: 'normal',
  },
  'button, [type="button"], [type="reset"], [type="submit"]': {
    WebkitAppearance: 'button',
    '&:not(:disabled)': {
      cursor: 'pointer',
    },
  },
  'button::-moz-focus-inner, [type="button"]::-moz-focus-inner, [type="reset"]::-moz-focus-inner, [type="submit"]::-moz-focus-inner':
    {
      padding: 0,
      borderStyle: 'none',
    },
  'input[type="radio"], input[type="checkbox"]': {
    boxSizing: 'border-box',
    padding: 0,
  },
  'input[type="date"], input[type="time"], input[type="datetime-local"], input[type="month"]':
    {
      WebkitAppearance: 'listbox',
    },
  textarea: {
    overflow: 'auto',
    resize: 'vertical',
  },
  fieldset: {
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
  },
  legend: {
    display: 'block',
    width: '100%',
    maxWidth: '100%',
    padding: 0,
    marginBottom: '0.5rem',
    fontSize: '1.5rem',
    lineHeight: 'inherit',
    color: 'inherit',
    whiteSpace: 'normal',
  },
  progress: {
    verticalAlign: 'baseline',
  },
  '[type="number"]::-webkit-inner-spin-button, [type="number"]::-webkit-outer-spin-button':
    {
      height: 'auto',
    },
  '[type="search"]': {
    outlineOffset: '-2px',
    WebkitAppearance: 'none',
  },
  '[type="search"]::-webkit-search-decoration': {
    WebkitAppearance: 'none',
  },
  '::-webkit-file-upload-button': {
    font: 'inherit',
    WebkitAppearance: 'button',
  },
  output: {
    display: 'inline-block',
  },
  summary: {
    display: 'list-item',
    cursor: 'pointer',
  },
  '@keyframes hf-spinner-border': {
    to: { transform: 'rotate(360deg)' },
  },
  ...muiWidgetGlobals,
}

export function cssBaselineStyleOverrides() {
  return cssBaselineOverrides
}
